// extracted by mini-css-extract-plugin
export default {"cardHead":"cardHead__DH9vvD","cardContent":"cardContent__LZ0ubp","striked":"striked__bpvOSk"};